import React, { useContext, useCallback, useState, useRef } from 'react';
import classNames from 'classnames';
import NavigationPane from './navigation-pane/NavigationPane';
import styles from './navigation.scss';
import EnvVarsFeaturesContext from '../../scaffold/EnvVarsFeaturesContext';
import getCategories from '../../../client/fetch/categories';

export const fetchChildCategories = async ({
  categories,
  categoryId,
  depth,
}) => {
  const childCategories = await getCategories({
    categoryId,
    depth,
  });
  return childCategories &&
    childCategories.items &&
    childCategories.items.length > 0
    ? {
        ...categories,
        items: categories.items.map(item =>
          item.id === categoryId
            ? {
                ...item,
                items: [...childCategories.items],
              }
            : item
        ),
      }
    : categories;
};

export const scrollRef = nav => {
  if (nav && nav.current && nav.current.scrollBy) {
    nav.current.scrollBy(0, -1000);
  }
};

function Navigation({ mobileNavShown }) {
  const nav = useRef();

  const { categories: rootCategories } = useContext(EnvVarsFeaturesContext);

  const [categories, setCategories] = useState({ ...rootCategories });

  const fetchDeepCategories = async categoryId => {
    const fetchedChildren = await fetchChildCategories({
      categories,
      categoryId,
      depth: 4,
    });

    setCategories(fetchedChildren);
  };

  const scrollToTop = useCallback(() => scrollRef(nav));
  const navigateToCategory = useCallback(categoryId =>
    fetchDeepCategories(categoryId)
  );

  return (
    <nav
      ref={nav}
      className={classNames(styles.container, {
        [styles.open]: mobileNavShown,
      })}
    >
      <div className={styles.capture} />
      <NavigationPane
        id="menu"
        title="Shop by department"
        items={categories.items}
        fetchAndStoreChildCategories={navigateToCategory}
        visible={mobileNavShown}
        scrollToTop={scrollToTop}
      />
      <div className={styles.overlay} />
    </nav>
  );
}

export default Navigation;
